<template>
	<div class="ui fluid labeled input">
        <input type="text" class="ssoinput" :value="value" @input="$emit('update-value', $event.target.value)" :placeholder="label">
    </div>
</template>

<script>
import router from '../router'

export default {
    props: ["label", "value"],
    name: 'labelinput',
    model: {
        prop: 'value',
        event: 'update-value'
    }
}
</script>
<style>
.ssoinput {
	border-bottom: 1px solid lightgray;
	background-color: rgba(255,255,255,0.9) !important; 
}
</style>